
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2154|2698|4320)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
